import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { MessageType } from '@zonofi/common';
import {
  usePublishMessageMutation,
  PublishMessagePayload,
  getWorkspaceId,
  dispatch,
  updateSendType,
  clearSelectedItemsMap,
  clearSelectedItemIds,
  useAppSelector,
  getUserData,
  getSelectedItems,
} from '@zonofi/zono-money-store';

export const useSendDispatchNote = (onSuccessNavigate?: () => void) => {
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);
  const userData = useAppSelector(getUserData);
  const selectedDispatchNotes = useAppSelector(getSelectedItems);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [publishMessage, publishRes] = usePublishMessageMutation();

  const onSendDispatchNote = () => {
    if (selectedDispatchNotes?.length === 0) return;
    const data = selectedDispatchNotes.map((dispatch) => ({
      id: dispatch.id,
      dispatchDate: dispatch.dispatchDate,
      dispatchDocNumber: dispatch.dispatchDocNumber,
      termsOfDelivery: dispatch.termsOfDelivery ?? '',
      transporterName: dispatch.transporterName ?? '',
      type: dispatch.type || 'Invoice',
      vehicleNumber: dispatch.vehicleNumber ?? '',
    }));

    const payload: PublishMessagePayload = {
      sellerWorkspaceId,
      inviteIds: [selectedDispatchNotes[0].inviteId],
      message: {
        type: MessageType.DISPACH_NOTE,
        _id: uuidv4(),
        cAt: moment().valueOf().toString(),
        chnType: 'C',
        _v: 2,
        source: 'system',
        data,
        sId: userData?.id,
        user: {
          firstName: userData?.firstName ?? '',
          lastName: userData?.lastName ?? '',
          mobile: userData?.mobile ?? '',
          email: userData?.email ?? '',
          id: userData?.id,
        },
      },
    };
    publishMessage(payload);
  };

  useEffect(() => {
    if (publishRes.isSuccess) {
      setShowSuccessModal(true);
    }
  }, [publishRes.isSuccess]);

  const onSuccessClose = () => {
    dispatch(updateSendType(''));
    dispatch(clearSelectedItemsMap());
    dispatch(clearSelectedItemIds());
    setShowSuccessModal(false);
    onSuccessNavigate?.();
  };

  return {
    onSendDispatchNote,
    isLoading: publishRes.isLoading,
    showSuccessModal,
    onSuccessClose,
  };
};
